import { render, staticRenderFns } from "./product-select-ajax.vue?vue&type=template&id=4a3191fa&scoped=true&"
import script from "./product-select-ajax.vue?vue&type=script&lang=js&"
export * from "./product-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3191fa",
  null
  
)

export default component.exports